// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { apolloProvider } from '@/setup/apollo'
import '@/setup/vue'
// import VueHead from 'vue-head'

// Vue.use(VueHead)
Vue.config.productionTip = false

import Quasar from 'quasar'

Quasar.start(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    apolloProvider,
    render: h => h(App),
  })
})



// WEBPACK FOOTER //
// ./src/main.js